/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

import React from 'react';
import {
  Box,
  ControlLabel,
  TextInputField,
  Text,
  View,
} from '@staffino/primitive-controls';
import Tooltip from '../tooltip';

type Props = {
  type?: string;
  invalid?: boolean;
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  label?: string;
  activeColor?: string;
  labelShowMandatory?: boolean;
  tooltip?: {
    content: any;
    placement?: any;
    showOn?: 'label' | 'input';
  };
  c?: string;
  name?: string;
  limit?: number;
  onKeyDown?: (event: React.KeyboardEvent) => void;
  onFocus?: () => void;
  requiredValidationMessage?: string;
  validationMessage?: string;
  blockId?: string;
} & React.ComponentProps<typeof Box>;

const TextInputControl: React.ForwardRefExoticComponent<
  Props & React.RefAttributes<unknown>
> = React.forwardRef(
  (
    {
      type,
      invalid,
      value,
      onChange,
      label,
      labelShowMandatory,
      tooltip,
      name,
      placeholder,
      activeColor,
      limit,
      onKeyDown,
      onFocus,
      requiredValidationMessage,
      validationMessage,
      ...rest
    }: Props,
    ref: React.Ref<unknown>,
  ) => {
    return (
      <Box {...rest}>
        <View style={{ display: 'flex' }}>
          <Tooltip
            tooltip={tooltip?.content}
            placement={tooltip?.placement}
            show={tooltip?.showOn === 'label'}
          >
            <ControlLabel label={label} showMandatory={labelShowMandatory} />
          </Tooltip>
          {!!requiredValidationMessage && (
            <Text color="notification" alignSelf="center">
              {requiredValidationMessage}
            </Text>
          )}
        </View>

        <Tooltip
          tooltip={tooltip?.content}
          placement={tooltip?.placement}
          show={tooltip?.showOn === 'input'}
        >
          <TextInputField
            ref={ref}
            type={type}
            invalid={invalid}
            activeColor={activeColor}
            value={value}
            placeholder={placeholder}
            name={name}
            limit={limit}
            onKeyDown={onKeyDown}
            onFocus={onFocus}
            onChange={onChange}
          />
        </Tooltip>
        {!!validationMessage && (
          <Text color="notification">{validationMessage}</Text>
        )}
      </Box>
    );
  },
);

export default TextInputControl;
